document.addEventListener("DOMContentLoaded", function () {
    var elem = document.querySelector('#AnnouncementSlider');
    var flkty = new Flickity(elem, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false, 
        pageDots: false,        
        wrapAround: true     
    });

    document.querySelector('.slider-prev').addEventListener('click', function () {
        flkty.previous();
    });

    document.querySelector('.slider-next').addEventListener('click', function () {
        flkty.next();
    });
});

// js-featured-slider
document.addEventListener("DOMContentLoaded", function () {
  var sliders = document.querySelectorAll('.js-featured-slider');

  let preloadQuickView = true;
  sliders.forEach(function (sliderElem) {
    var flkty = new Flickity(sliderElem, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      groupCells: false
    });

    // console.log("flkty",flkty);

    flkty.element.on('click', function(event, pointer, cellElement, cellIndex) {
      // if (!cellElement) return;
      // console.log("staticClick>>>>>>>>>>",event.target);
      if(preloadQuickView && event.target.classList.contains("quick-product__btn")){
        console.log("btn clicked",event.target.closest(".grid-product").querySelector(".quick-product__btn:not(.quick-product__btn-custom_quickview)"));
        preloadQuickView = false;
        theme.preloadProductModal(event.target.closest(".grid-product").dataset.productHandle, event.target.closest(".grid-product").dataset.productId, event.target);
        setTimeout( () => {
          event.target.click();
        },1000);
      }
    });


    var wrapper = sliderElem.closest('.featured-products-wrapper');
    var prevBtn = wrapper.querySelector('.slider-prev');
    var nextBtn = wrapper.querySelector('.slider-next');
    var currentEl = wrapper.querySelector('.slider-current');
    var totalEl = wrapper.querySelector('.slider-total');

    if (totalEl) totalEl.textContent = flkty.slides.length;

    flkty.on('change', function (index) {
      if (currentEl) currentEl.textContent = index + 1;
    });

    if (prevBtn) prevBtn.addEventListener('click', () => flkty.previous());
    if (nextBtn) nextBtn.addEventListener('click', () => flkty.next());

    // ✅ Equal height for all slides
    function setEqualHeight() {
      var cells = sliderElem.querySelectorAll('.carousel-cell');
      let maxHeight = 0;

      cells.forEach(cell => {
        cell.style.height = "auto"; // reset first
        maxHeight = Math.max(maxHeight, cell.offsetHeight);
      });

      cells.forEach(cell => {
        cell.style.height = maxHeight + "px";
      });
    }

    // Run on load + after images load + on resize
    setEqualHeight();
    window.addEventListener('resize', setEqualHeight);

    flkty.on('imagesLoaded', setEqualHeight);
  });
});



// Video Section
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll("[id^='VideoPlayBtn-']").forEach(function(btn) {
    btn.addEventListener("click", function() {
      var sectionId = this.id.replace("VideoPlayBtn-", "");
      var poster = document.getElementById("VideoPoster-" + sectionId);
      var iframeWrapper = document.getElementById("VideoIframe-" + sectionId);
      var iframe = iframeWrapper.querySelector("iframe");

      poster.classList.add("hidden");

      iframeWrapper.classList.remove("hidden");

      iframe.src = iframe.getAttribute("data-src");
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const share = document.querySelector(".custom-share");
  if (!share) return;

  const trigger = share.querySelector(".custom-share__trigger");
  const popup = share.querySelector(".custom-share__popup");
  const copyBtn = share.querySelector(".custom-share__copy");
  const input = share.querySelector(".custom-share__link");

  const originalValue = input.value;

  // toggle popup
  trigger.addEventListener("click", (e) => {
    e.stopPropagation(); // prevent document click from firing
    popup.style.display = popup.style.display === "block" ? "none" : "block";
    if (popup.style.display === "block") {
      input.value = originalValue;
      input.style.color = "";
    }
  });

  // copy link
  copyBtn.addEventListener("click", (e) => {
    e.stopPropagation(); // don’t trigger outside click close
    input.select();
    navigator.clipboard.writeText(originalValue).then(() => {
      input.value = "Copied successfully!";
      input.style.color = "green";
      setTimeout(() => {
        input.value = originalValue;
        input.style.color = "";
      }, 2000);
    });
  });

  // close popup on outside click
  document.addEventListener("click", (e) => {
    if (!share.contains(e.target)) {
      popup.style.display = "none";
      input.value = originalValue;
      input.style.color = "";
    }
  });
});



//  const headerHeight = document.querySelector('.header-wrapper').offsetHeight;
//  const AnnoucmentHeight = document.querySelector('.announcement-bar').offsetHeight;
//  const bothHeight = headerHeight + AnnoucmentHeight; 
//  document.querySelector('html.js').style = `--header-bottom-position: ${bothHeight}px;`

// Bss custom script menu/cart drawer
function updateHeaderPosition() {
  const header = document.querySelector('.header-wrapper');
  const topOffset = header.getBoundingClientRect().top;

  if (!header) return;

  let bothHeight = 0;

  bothHeight = (header.offsetHeight || 0) + topOffset;
  if (bothHeight < 0) {
    bothHeight = header.offsetHeight;
  }

  document.documentElement.style.setProperty('--header-bottom-position', bothHeight + 'px');
}

updateHeaderPosition();
window.addEventListener('scroll', updateHeaderPosition);
window.addEventListener('resize', updateHeaderPosition);
